const MODIFIER_LABELS: Record<string, { win: string; mac: string }> = {
    alt:   { win: 'Alt',   mac: 'Option' },
    shift: { win: 'Shift', mac: 'Shift'  },
    ctrl:  { win: 'Ctrl',  mac: 'Ctrl'   },
};

function isMac(): boolean {
    if (typeof navigator === 'undefined') return false;
    const platform = (navigator as any).userAgentData?.platform ?? navigator.platform;
    return platform.toLowerCase().includes('mac');
}

export function getShortcutLabel(shortcut: string): string {
    const parts = shortcut.toLowerCase().split('+');
    const key = parts[parts.length - 1].toUpperCase();
    const modifiers = parts.slice(0, -1);
    const mac = isMac();
    const labels = modifiers.map(mod => MODIFIER_LABELS[mod]?.[mac ? 'mac' : 'win'] ?? mod);
    return [...labels, key].join('+');
}
